import { Theme } from '@infotech-soe/erp-ui-kit';
import { createSlice } from '@reduxjs/toolkit';

import { AllowedThemeName, DEFAULT_THEME } from '../../constants/theme';

import { failureAction, pendingAction, successAction } from './actionHandler';

interface ThemeState {
  current: Theme;
  name: AllowedThemeName;
  error: Error | null;
}

const initialState: ThemeState = {
  current: {} as Theme,
  name: DEFAULT_THEME,
  error: null,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    apply: pendingAction<ThemeState, AllowedThemeName | null>(),
    applySuccess: successAction<
      ThemeState,
      { theme: Theme; name: AllowedThemeName }
    >((state, { payload: { theme, name } }) => {
      state.current = theme;
      state.name = name;
      state.error = null;
    }),
    applyFailure: failureAction<ThemeState>((state, { payload }) => {
      state.error = payload;
    }),
  },
});

export const themeReducer = themeSlice.reducer;

export default themeSlice.actions;
